import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { ConnectionService } from '../../service/connection.service';
import { LoadErrorComponent } from '../../components/load-error/load-error.component';

@Component({
  selector: 'app-team-matrimoni',
  standalone: true,
  imports: [CommonModule, LoadErrorComponent],
  templateUrl: './team-matrimoni.component.html',
  styleUrl: './team-matrimoni.component.css',
})
export class TeamMatrimoniComponent implements OnInit {
  events: any[] = [];
  loading = true;

  constructor(private connection: ConnectionService, private router: Router) {}

  loadError = false;

  ngOnInit() {
    this.load();
  }

  load() {
    this.loadError = false;
    this.loading = true;
    this.connection.get(
      '@events',
      (data: any[]) => {
        this.events = (data ?? []).sort((a, b) =>
          (a.event?.date ?? '') > (b.event?.date ?? '') ? 1 : -1,
        );
        this.loading = false;
      },
      () => {
        this.loading = false;
        this.loadError = true;
      },
    );
  }

  openEvent(id: string) {
    this.router.navigate(['/team/evento', id]);
  }

  formatDate(d: string): string {
    if (!d) return '—';
    const [y, m, day] = d.split('-');
    return `${day}/${m}/${y}`;
  }

  // Date formattate via Intl (l'app non registra il locale Angular)
  dayOf(d: string): string {
    if (!d) return '—';
    return new Date(d).toLocaleDateString('it-IT', { day: 'numeric' });
  }

  monthOf(d: string): string {
    if (!d) return '';
    return new Date(d).toLocaleDateString('it-IT', { month: 'short' });
  }

  yearOf(d: string): string {
    if (!d) return '';
    return new Date(d).toLocaleDateString('it-IT', { year: 'numeric' });
  }

  isPast(d: string): boolean {
    return !!d && d < new Date().toISOString().slice(0, 10);
  }
}
